import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'

import './index.css'
import { queryClient } from '@/lib/queryClient'
import { configureApiClient } from '@/lib/apiClient'
import { routeTree } from './routeTree.gen'

// Same-origin in production: CloudFront reroutes /v1/public/* to the consent API Gateway, so no
// base is needed. VITE_API_BASE_URL is an escape hatch for non-standard hosting (normally unset).
configureApiClient({ baseUrl: import.meta.env.VITE_API_BASE_URL as string | undefined })

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="top-center" />
    </QueryClientProvider>
  </StrictMode>,
)
